export default "__VITE_ASSET__43b4482b__"